exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".RegionalEmbed-dbca94de .marker-cluster{background-color:rgba(0,0,0,0.5)}.RegionalEmbed-dbca94de .marker-cluster div{background-color:rgba(0,0,0,0.65)}.RegionalEmbed-dbca94de .marker-cluster span{color:#fff}\n", ""]);

// Exports
exports.locals = {
	"RegionalEmbed": "RegionalEmbed-dbca94de"
};